<h2 class="text-2xl font-bold">{{ '#RDP_LOG.OVERVIEW_PAGE.PAGE_TITLE' | translate }}</h2>

<!-- show active filters -->
@if (query$ | async; as query) {
  <div class="mt-1">
    @if (query.from || query.to) {
      <div class="flex flex-col">
        <strong>{{ '#RDP_LOG.OVERVIEW_PAGE.FILTER_HEADING' | translate }}</strong>
      </div>
    }
    <soft-chip-group class="flex flex-row">
      @if (query.from) {
        <soft-chip class="chips-spacing">
          <strong>{{ '#RDP_LOG.OVERVIEW_PAGE.FILTER_FROM' | translate }}</strong> {{query.from | date:'dd.LL.yyyy'}}
        </soft-chip>
      }
      @if (query.to) {
        <soft-chip class="chips-spacing">
          <strong>{{ '#RDP_LOG.OVERVIEW_PAGE.FILTER_TO' | translate }}</strong> {{query.to  | date:'dd.LL.yyyy'}}
        </soft-chip>
      }
    </soft-chip-group>
  </div>
}

<!-- list of rdp log entries -->
<div class="flex flex-col">
  <ul class="soft-list">
    <li class="list-column-description">
      <div class="column-1"><strong>{{ '#RDP_LOG.OVERVIEW_PAGE.LIST_HEADING_CONNECTION' | translate }}</strong></div>
      <div class="column-2 column-2-header"><strong>{{ '#RDP_LOG.OVERVIEW_PAGE.LIST_HEADING_DETAILS' | translate }}</strong></div>
      <div class="column-3 column-3-header"><strong>{{ '#RDP_LOG.OVERVIEW_PAGE.LIST_HEADING_PROMPT' | translate }}</strong></div>
      <div class="column-4 column-4-header"><strong>{{ '#RDP_LOG.OVERVIEW_PAGE.LIST_HEADING_ACTIONS' | translate }}</strong></div>
    </li>
    @for (log of (logs$ | async); track log) {
      <li class="soft-list-item separate">
        <div class="column-1">
          <p><strong>{{ log.connectionName }}</strong></p>
          <p>{{log.username}} @if (log.connectionUsername) {
            <span>  &nbsp;|&nbsp;  {{ log.connectionUsername }}</span>
          }</p>
        </div>
        <div class="column-2">
          <div class="infos">
            <div class="info">
              <span class="info-detail-text">{{ log.startDateTime | date:'dd.LL.yyyy' }}</span>
            </div>
            <div class="info">
              <span class="info-detail-text">{{ log.startDateTime | date:'HH:mm' }} - {{ (log.endDateTime || log.startDateTime) | date:'HH:mm' }} ({{log.duration || '00:00:00'}})</span>
            </div>
            @if (log.ticketNumber) {
              <div class="info" >
                <span class="info-detail-text">{{ '#RDP_LOG.OVERVIEW_PAGE.TICKET' | translate }}:
                  <a class="soft-link" [routerLink]="['/ticket', {id: log.ticketNumber}]">{{log.ticketNumber}}</a>
                </span>
              </div>
            }
          </div>
        </div>
        <div class="column-3">
          {{log.prompt}}
        </div>
        <div class="column-4">
          @if (log.file && !(downloadRequests$ | async | isFileDownloading:log.file)) {
            <a class="soft-link" (click)="downloadFile(log.file)">
              <i class="fa-regular fa-cloud-arrow-down"></i>
            </a>
          }
          @if (downloadRequests$ | async | isFileDownloading:log.file) {
            <i class="fa-regular fa-spinner fa-spin"></i>
          }
        </div>
      </li>
    }
  </ul>
</div>
@if (loading$ | async) {
  <div class="flex flex-row justify-center">
    <soft-loading-spinner class="mt-3"></soft-loading-spinner>
  </div>
}
@if (!(loading$ | async) && (loaded$ | async) && (total$ | async) === 0) {
  <div class="flex flex-row justify-center mt-10">
    {{'#RDP_LOG.MESSAGE.NO_DATA' | translate}}
  </div>
}
